module.exports = __webpack_public_path__ + "static/media/2019-02-15-01.1691b645.jpg";